import { AccountLayout, burn, createAssociatedTokenAccountInstruction, createBurnInstruction, createTransferInstruction, getAssociatedTokenAddress, getOrCreateAssociatedTokenAccount } from "@solana/spl-token"
import { PublicKey, Transaction, TransactionInstruction } from "@solana/web3.js";
import { getSolanaProvider } from "./solana"
import { Provider } from '@project-serum/anchor';
import { MEMO_ID } from "../utils/program-constants";
import { memoize } from "../utils/helpers";

export const TOKEN_PROGRAM_ID = new PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA');

export const burnNFT = async (wallet: any, mint: any) => {
    console.log(wallet.publicKey.toString());
    console.log(mint);
    const provider = getSolanaProvider(wallet);


    const mintPublicKey = new PublicKey(mint);
    const tokenAccount = await getOrCreateAssociatedTokenAccount(
        provider.connection,
        wallet,
        mintPublicKey,
        wallet.publicKey
    );
    const burnResponse = await burnMe(
        provider,
        tokenAccount.address,
        mintPublicKey,
        wallet.publicKey,
        1,
        undefined,
        TOKEN_PROGRAM_ID
    );
    console.log(burnResponse);
}

export const checkForInvalidTokenAccountsInstructions = async (wallet: any, mints: any) => {
    const provider = getSolanaProvider(wallet);
    const instructions = [];
    for (const mint of mints) {
        const mintPublicKey = new PublicKey(mint);
        let tokenAccount;
        try {
            tokenAccount = await getOrCreateAssociatedTokenAccount(
                provider.connection,
                wallet,
                mintPublicKey,
                wallet.publicKey
            );
        } catch (error: any) {
            if (error.name === 'TokenAccountNotFoundError' || error.name === 'TokenInvalidAccountOwnerError') {
                const associatedToken = await getAssociatedTokenAddress(
                    mintPublicKey,
                    provider.wallet.publicKey
                );
                instructions.push(createAssociatedTokenAccountInstruction(
                    provider.wallet.publicKey,
                    associatedToken,
                    provider.wallet.publicKey,
                    mintPublicKey
                ));
            }
        }
    }
    return instructions;
}

export const checkForInvalidTokenAccountsAndExecute = async (wallet: any, mints: any) => {
    const provider = getSolanaProvider(wallet);
    const instructions = [];
    for (const mint of mints) {
        const mintPublicKey = new PublicKey(mint);
        let tokenAccount;
        try {
            tokenAccount = await getOrCreateAssociatedTokenAccount(
                provider.connection,
                wallet,
                mintPublicKey,
                wallet.publicKey
            );
        } catch (error: any) {
            if (error.name === 'TokenAccountNotFoundError' || error.name === 'TokenInvalidAccountOwnerError') {
                const associatedToken = await getAssociatedTokenAddress(
                    mintPublicKey,
                    provider.wallet.publicKey
                );
                instructions.push(createAssociatedTokenAccountInstruction(
                    provider.wallet.publicKey,
                    associatedToken,
                    provider.wallet.publicKey,
                    mintPublicKey
                ));
            }
        }
    }

    if (!instructions?.length) {
        return;
    }
    
    const tx = new Transaction();
    for (const ix of instructions) {
        tx.add(ix);
    }
    return await provider.send(tx);
}

export const signInstructions = async (wallet: any, instructions: any[]) => {
    const provider = getSolanaProvider(wallet);
    const tx = new Transaction();
    instructions.map((instruction: any) => tx.add(instruction));
    for (const ix of instructions) {
        tx.add(ix);
    }
    return await provider.send(tx);
}

export const burnNFTs = async (wallet: any, mints: any, id: string) => {
    const provider = getSolanaProvider(wallet);

    const instructions = [];

    for (const mint of mints) {
        const mintPublicKey = new PublicKey(mint);
        const tokenAccount = await getOrCreateAssociatedTokenAccount(
            provider.connection,
            wallet,
            mintPublicKey,
            wallet.publicKey
        );
        const instruction = await burnInstruction(
            provider,
            tokenAccount.address,
            mintPublicKey,
            wallet.publicKey,
            1,
            undefined,
            TOKEN_PROGRAM_ID
        );

        instructions.push(instruction);
    }

    const tx = new Transaction();

    tx.add(new TransactionInstruction({
        keys: [{ pubkey: provider.wallet.publicKey, isSigner: true, isWritable: true }],
        data: Buffer.from(`id=${id}`, "utf-8"),
        programId: MEMO_ID
    }));
    for (const ix of instructions) {
        tx.add(ix);
    }

    return await provider.send(tx);

}

export const createBurnTx = async (wallet: any, mint: any) => {
    console.log(wallet.publicKey.toString());
    console.log(mint);
    const provider = getSolanaProvider(wallet);


    const mintPublicKey = new PublicKey(mint);
    const tokenAccount = await getOrCreateAssociatedTokenAccount(
        provider.connection,
        wallet,
        mintPublicKey,
        wallet.publicKey
    );
    const tx = await burnTx(
        tokenAccount.address,
        mintPublicKey,
        wallet.publicKey,
        1,
        undefined,
        TOKEN_PROGRAM_ID
    );

    return tx;
}
/**
 * Burn tokens from an account
 *
 * @param connection     Connection to use
 * @param payer          Payer of the transaction fees
 * @param account        Account to burn tokens from
 * @param mint           Mint for the account
 * @param owner          Account owner
 * @param amount         Amount to burn
 * @param multiSigners   Signing accounts if `owner` is a multisig
 * @param confirmOptions Options for confirming the transaction
 * @param programId      SPL Token program account
 *
 * @return Signature of the confirmed transaction
 */
export async function burnMe(provider: Provider, account: any, mint: any, owner: any, amount: any, multiSigners = [], confirmOptions: any, programId = TOKEN_PROGRAM_ID) {
    const tx = new Transaction().add(createBurnInstruction(account, mint, owner, amount, multiSigners, programId));
    return await provider.sendAll([{ tx, signers: [undefined] }]);
    // return await provider.send(transaction);
    // return await sendAndConfirmTransaction(connection, transaction, [payer], confirmOptions);
}
//# sourceMappingURL=burn.js.map

export async function burnInstruction(provider: Provider, account: any, mint: any, owner: any, amount: any, multiSigners = [], confirmOptions: any, programId = TOKEN_PROGRAM_ID) {
    return createBurnInstruction(account, mint, owner, amount, multiSigners, programId);
    // return await provider.send(transaction);
    // return await sendAndConfirmTransaction(connection, transaction, [payer], confirmOptions);
}

export async function burnTx(account: any, mint: any, owner: any, amount: any, multiSigners = [], confirmOptions: any, programId = TOKEN_PROGRAM_ID) {
    const tx = new Transaction().add(createBurnInstruction(account, mint, owner, amount, multiSigners, programId));
}
//# sourceMappingURL=burn.js.map